import { create } from 'zustand';

export interface OrderbookStore {
  price: string;
  setPrice: (price: OrderbookStore['price']) => void;
  isUsdc: boolean;
  setIsUsdc: (isUsdc: OrderbookStore['isUsdc']) => void;
  expiration: number | null;
  setExpiration: (expiration: OrderbookStore['expiration']) => void;
  solAmount: number;
  setSolAmount: (solAmount: OrderbookStore['solAmount']) => void;
}

export const useOrderbookStore = create<OrderbookStore>((set) => ({
  price: '50',
  setPrice: (price: OrderbookStore['price']) => {
    set({ price });
  },
  isUsdc: true,
  setIsUsdc: (isUsdc: OrderbookStore['isUsdc']) => {
    set({ isUsdc });
  },
  expiration: null,
  setExpiration: (expiration: OrderbookStore['expiration']) => {
    set({ expiration });
  },
  solAmount: 0,
  setSolAmount: (solAmount: OrderbookStore['solAmount']) => {
    set({ solAmount });
  },
}));
